import CurrencyPairItemCFD from './CurrencyPairItemCFD';

export default CurrencyPairItemCFD;
